import { LoadingWidgetInterface } from './dashboard-driver.interface';

export const defaultLoadingWidget: LoadingWidgetInterface = {
  vehicle: true,
  upcomingTasks: true,
  myOrder: true
};
